import React from "react";
import { BgImage } from "gbimage-bridge";

export default function SplashTitle({
  image,
  gradient = "linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 20%, rgba(0,0,0,0.5) 80%, rgba(0,0,0,0) 100%)",
  subheadline,
  children,
}) {
  const imageStack = [gradient, image];

  return (
    <BgImage image={imageStack} alt="" className="flex flex-col justify-center" style={{ height: "400px" }}>
      <div>
        <div className="max-w-7xl mx-auto px-8 text-white">
          {/* <h2 className="text-base font-semibold uppercase tracking-wider">{subheadline}</h2> */}
          {/* <h1 className="mt-2 text-white text-3xl font-extrabold tra  cking-tight sm:text-4xl lg:text-6xl"> */}
          <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-6xl">{subheadline}</h2>
          <h1 className="text-2xl mt-1 sm:mt-2 font-medium tracking-tighter sm:text-3xl lg:text-5xl">{children}</h1>
        </div>
      </div>
    </BgImage>
  );
}
